import type { ReactNode } from 'react'

import { UnknownContentFallback } from './split-view-fallbacks.atom'
import { SplitViewWrapper } from './split-view-wrapper.atom'

export interface SplitViewUnknownProps {
  onClose: () => void
  isCloseButtonHidden?: boolean
  className?: string
}

export const SplitViewUnknown: React.FC<SplitViewUnknownProps> = ({
  onClose,
  isCloseButtonHidden = false,
  className,
}): ReactNode => (
  <SplitViewWrapper
    title="Unknown"
    onClose={onClose}
    isCloseButtonHidden={isCloseButtonHidden}
    className={className}
  >
    <UnknownContentFallback />
  </SplitViewWrapper>
)
